"use strict";

$(document).ready(function () {
  var $addVoucherForm = $('.form__add-voucher');
  var $voucherField = $addVoucherForm.find('.voucherField');
  var $giftcardField = $addVoucherForm.find('.giftcardField');
  var $voucherError = '.promo-code-alert .js-error-text';
  $($voucherError).on("DOMSubtreeModified", function () {
    $voucherField.addClass('input-error');
    $giftcardField.addClass('input-error');
  });

  if ($('.scroll-to-top-btn').length > 0) {
    var winTop = $(window).scrollTop();
    var winHeight = $(window).height();

    if (winTop > winHeight) {
      if ($('.scroll-to-top-btn').hasClass('hide')) {
        $('.scroll-to-top-btn').removeClass('hide');
      }
    } else {
      if (!$('.scroll-to-top-btn').hasClass('hide')) {
        $('.scroll-to-top-btn').addClass('hide');
      }
    }
  }

  $('.scroll-to-top-btn').click(function () {
    var scroll_pos = 0;
    $('html, body').animate({
      scrollTop: scroll_pos
    }, '1000');
  });
  $(window).on('scroll', function (e) {
    if ($('.scroll-to-top-btn').length > 0) {
      if ($(window).scrollTop() > $(window).height()) {
        if ($('.scroll-to-top-btn').hasClass('hide')) {
          $('.scroll-to-top-btn').removeClass('hide');
        }
      } else {
        if (!$('.scroll-to-top-btn').hasClass('hide')) {
          $('.scroll-to-top-btn').addClass('hide');
        }
      }
    }
  });
});